var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/01 Small/ic-clear") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/01-Small/ic-clear",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uF00D",
    transform: "translate(6.375000, 6.625000)",
    fill: "#ABAEB1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9335938,1.93359375 C11.1445312,1.69921875 11.25,1.4296875 11.25,1.125 L11.25,1.125 C11.25,0.8203125 11.1445312,0.55078125 10.9335938,0.31640625 C10.6992188,0.10546875 10.4296875,0 10.125,0 C9.8203125,0 9.55078125,0.10546875 9.31640625,0.31640625 L5.625,4.04296875 L1.93359375,0.31640625 C1.69921875,0.10546875 1.4296875,0 1.125,0 C0.8203125,0 0.55078125,0.10546875 0.31640625,0.31640625 C0.10546875,0.55078125 0,0.8203125 0,1.125 C0,1.4296875 0.10546875,1.69921875 0.31640625,1.93359375 L4.04296875,5.625 L0.31640625,9.31640625 C0.10546875,9.55078125 0,9.8203125 0,10.125 C0,10.4296875 0.10546875,10.6992188 0.31640625,10.9335938 C0.55078125,11.1445312 0.8203125,11.25 1.125,11.25 C1.4296875,11.25 1.69921875,11.1445312 1.93359375,10.9335938 L5.625,7.20703125 L9.31640625,10.9335938 C9.55078125,11.1445312 9.8203125,11.25 10.125,11.25 C10.4296875,11.25 10.6992188,11.1445312 10.9335938,10.9335938 C11.1445312,10.6992188 11.25,10.4296875 11.25,10.125 C11.25,9.8203125 11.1445312,9.55078125 10.9335938,9.31640625 L7.20703125,5.625 L10.9335938,1.93359375 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic-close.1f4ca8e9ba862b999c16bfa7c8b7da1c.svg";
export { ForwardRef as ReactComponent };